/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { scopes } from '../constants/auth';
import { AccountInfo, AuthenticationResult } from '@azure/msal-browser';
import { User } from '../models/auth';
import { avatarType } from '../constants';

const useMsalHook = () => {
  const { instance } = useMsal();
  const [userToken, setUserToken] = useState<string | undefined>(undefined);
  const [user, setUser] = useState<User | undefined>(undefined);

  const handleAccount = async () => {
    // Leer el state del hash ANTES de que MSAL lo consuma (viene del redirect de Microsoft)
    const hashRaw = window.location.hash;
    const hashParams = new URLSearchParams(hashRaw.replace(/^#/, ''));
    const rawStateFromHash = hashParams.get('state');
    //console.log('[MSAL] hash state raw:', rawStateFromHash);

    if (rawStateFromHash) {
      // MSAL codifica el state como: <json_msal>|<nuestro_state>
      const decoded = decodeURIComponent(rawStateFromHash);
      //console.log('[MSAL] hash state decoded:', decoded);
      const pipeIdx = decoded.lastIndexOf('|');
      const pathFromState = pipeIdx !== -1 ? decoded.slice(pipeIdx + 1) : null;
      //console.log('[MSAL] pathFromState:', pathFromState);
      if (pathFromState && pathFromState !== '/') {
        sessionStorage.setItem('preLoginPath', pathFromState);
        console.log('[MSAL] guardado en sessionStorage:', pathFromState);
      }
    }

    const redirectResult = await instance.handleRedirectPromise();
    const activeAccount =
      redirectResult?.account ?? instance.getActiveAccount();

    if (activeAccount) {
      instance.setActiveAccount(activeAccount);

      const savedPath = sessionStorage.getItem('preLoginPath');
      //console.log('[MSAL] savedPath del sessionStorage:', savedPath);
      if (savedPath && savedPath !== '/') {
        sessionStorage.removeItem('preLoginPath');
        if (window.location.pathname !== savedPath) {
          console.log('[MSAL] redirigiendo a:', savedPath);
          window.location.replace(savedPath);
          return;
        }
      }

      setAccessToken(activeAccount);
    } else {
      const pathToSave = window.location.pathname;
      console.log('[MSAL] sin sesión, path actual a guardar en state:', pathToSave);
      await instance.loginRedirect({
        scopes,
        state: pathToSave,
      });
    }
  };

  const setAccessToken = async (activeAccount: AccountInfo) => {
    let accessTokenResponse: AuthenticationResult | undefined;
    try {
      accessTokenResponse = await instance.acquireTokenSilent({
        account: activeAccount,
        scopes,
      });
    } catch (error: any) {
      console.log('get token catch ->', error.message);
      if (error?.message?.includes('login_required')) {
        await instance.loginRedirect({
          scopes,
          state: window.location.pathname,
        });
      }
    }
    if (accessTokenResponse) {
      const { accessToken, account } = accessTokenResponse;
      const { name, username } = account;
      setUser({ name, email: username, role: ''});
      setUserToken(accessToken);
    }
  };

  const logout = async () => {
    try {
      await instance.logoutRedirect();
    } catch (error) {
      console.error('error on logout', error);
    }
  };

  useEffect(() => {
    try {
      if (!userToken && avatarType?.toLowerCase() === 'gptceu') {
        handleAccount();
      }
    } catch (error: any) {
      console.log('catch error', error);
      if (error?.message.includes('popup_window_error')) {
        alert('Allow pop-ups to make login');
      }
    }
  }, [userToken]);

  return { user, userToken, logout };
};

export default useMsalHook;
